'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = isString;
function isString(maybe) {
    return typeof maybe === 'string';
}


//////////////////
// WEBPACK FOOTER
// ../~/react-custom-scrollbars-patched/lib/utils/isString.js
// module id = 2767
// module chunks = 1